export default import.meta.ROLLUP_FILE_URL_qqrTrr_ye7YgQc4KEDu4$w